{
  "pt": {
    "pagination": {
      "previous": "Página anterior",
      "next": "Página seguinte",
      "page_report": "Página {page} de {total}",
      "report": "A mostrar {first} a {last} de {total}",
      "total": "Total de itens: {total}"
    }
  }
}
